import {ItemType,ItemSubtype,SkillType,SkillTargetType,SkillTargetRestrict} from 'eolib';
import {useClient} from '@/ui/context';
import {Button} from '@/ui/components';
import {UI_ITEM_BG,UI_PANEL_BORDER} from '@/ui/consts';
import {requestMastery,type MasteryView} from '@/spell-mastery';

export function isStaffSpell(client:ReturnType<typeof useClient>,id:number){
 const spell=client.getEsfRecordById(id);
 return !!spell&&spell.type===SkillType.Attack&&spell.targetType===SkillTargetType.Normal&&spell.targetRestrict!==SkillTargetRestrict.Friendly&&![33,34,35,36,37,39,40,38,45,46,47].includes(id);
}
export function isEquipmentSkill(client:ReturnType<typeof useClient>,id:number,view:MasteryView,slot:'staff'|'shield'='staff'){
 const spell=client.getEsfRecordById(id),equipped=view[slot],item=equipped&&client.getEifRecordById(equipped.item_id);
 if(!spell||!item||!equipped?.key)return false;
 if(slot==='shield')return item.type===ItemType.Shield&&item.subtype!==ItemSubtype.Arrows&&!/book/i.test(item.name)&&[37,38,47].includes(id);
 if(item.type!==ItemType.Weapon)return false;
 if(item.subtype===ItemSubtype.Ranged)return [35,36,46].includes(id);
 if(item.name.toLowerCase().split(/\s+/).some(w=>['staff','lens'].includes(w)))return isStaffSpell(client,id);
 return [33,34,39,40,45].includes(id);
}
export function StaffSpellPanel({id,view}:{id:number;view:MasteryView}) {
 const client=useClient();
 const slot=isEquipmentSkill(client,id,view,'shield')?'shield':'staff';
 if(!isEquipmentSkill(client,id,view,slot))return null;
 const item=view[slot]!,equipped=item.spell_id===id;
 return <section class={`rounded border ${UI_PANEL_BORDER} ${UI_ITEM_BG} p-2 space-y-2`}>
  <strong>{slot==='shield'?'Shield':'Weapon'} Skill</strong>
  <p>{client.getEifRecordById(item.item_id)?.name}</p>
  <Button disabled={view.pending} onClick={()=>requestMastery(client,'equip_staff',equipped?0:id,item.key!)}>{equipped?'Unequip Skill':`Equip to ${slot==='shield'?'Shield':'Weapon'}`}</Button>
  <p class='text-xs opacity-75'>{slot==='shield'&&[38,47].includes(id)?'15% chance to react to an incoming hit. Uses mana only when activated; shares your manual-cast cooldown.':'Free to swap. Normal attacks use the equipped skill and spend mana. Staff spells use normal attack speed; weapon techniques keep their cooldowns.'}</p>
 </section>;
}
export function StaffSpellSelector({view}:{view:MasteryView}){
 const client=useClient();
 return <section class={`rounded border ${UI_PANEL_BORDER} ${UI_ITEM_BG} p-2 space-y-2`} data-staff-selector>
  <strong>Equipped Skills</strong>
  {(['staff','shield'] as const).map(slot=>{
   const item=view[slot],key=item?.key;
   return <label key={slot} class='text-xs block'>
    {slot==='shield'?'Shield':'Weapon'}: {key?client.getEifRecordById(item!.item_id)?.name:'None equipped'}
    <select aria-label={`Equip skill to ${slot==='shield'?'shield':'weapon'}`} class='select select-sm mt-1 w-full' disabled={!key||view.pending} value={item?.spell_id??0} onChange={e=>requestMastery(client,'equip_staff',Number(e.currentTarget.value),key!)}>
     <option value={0}>None — remove equipped skill</option>
     {client.spells.filter(s=>isEquipmentSkill(client,s.id,view,slot)).map(s=><option key={s.id} value={s.id}>{client.getEsfRecordById(s.id)?.name}</option>)}
    </select>
   </label>;
  })}
  <p class='text-xs opacity-75'>Select a compatible learned skill. Changes are free; no forge required.</p>
  {view.error&&<p role='alert' class='text-error'>{view.error}</p>}
 </section>;
}
